angular.module("app").directive("sportTeamColorModalDetail", () => {
  let link = (scope) => {
    scope.allData = {
      data: scope.logodata,
      index: scope.index,
    };

    scope.data = scope.logodata[scope.index];

    scope.LeftButtonHandler = () => {
      let index = scope.allData.index;
      if (index > 0) {
        index--;
      }
      scope.allData.index = index;
      scope.data = scope.allData.data[index];
    };

    scope.RightButtonHandler = () => {
      try {
        let index = scope.allData.index;
        if (index < scope.allData.data.length - 1) {
          index++;
        }
        scope.allData.index = index;
        scope.data = scope.allData.data[index];
      } catch (e) {}
    };

    scope.closeClickHandler = () => {
      scope.closefunction();
    };

    scope.shareFacebook = (url) => {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
    };

    scope.shareTwitter = (url) => {
      window.open("https://twitter.com/home?status=" + url);
    };

    scope.sharePinterest = (url) => {
      window.open("https://pinterest.com/pin/create/button/?url=" + url);
    };

    scope.shareGooglePlus = (url) => {
      window.open("https://plus.google.com/share?url=" + url);
    };

    // dummy data
    scope.colorDummyData = [
      { hex: "#a4a4a4", R: 164, G: 164, B: 164},
      { hex: "#d7d7d7", R: 215, G: 215, B: 215},
      { hex: "#2a2a2b", R: 42, G: 42, B: 43},
      { hex: "#717171", R: 113, G: 113, B: 113},
      { hex: "#9e9e9e", R: 158, G: 158, B: 158},
      { hex: "#a4a4a4", R: 164, G: 164, B: 164},
      { hex: "#d7d7d7", R: 215, G: 215, B: 215},
      { hex: "#2a2a2b", R: 42, G: 42, B: 43},
      { hex: "#717171", R: 113, G: 113, B: 113},
      { hex: "#9e9e9e", R: 158, G: 158, B: 158},
    ]

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbSportUsedColorAcrossTeams/dbSportTeamColorModal.html",
    link: link,
    scope: {
      logodata: "=",
      index: "=",
      onClose: "&",
      closefunction: "=",
    },
  };
});
